/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Allocation_Form_Delete_AllocationInputs */

const en_admin_allocation_form_delete_allocation = /** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete this allocation.`)
};

const de_admin_allocation_form_delete_allocation = /** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Zuweisung löschen.`)
};

const es_admin_allocation_form_delete_allocation = /** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar esta asignación.`)
};

const fr_admin_allocation_form_delete_allocation = /** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer cette attribution.`)
};

const nl_admin_allocation_form_delete_allocation = /** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze toewijzing verwijderen.`)
};

/** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */
const it_admin_allocation_form_delete_allocation = en_admin_allocation_form_delete_allocation;

/** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */
const pt_br2_admin_allocation_form_delete_allocation = en_admin_allocation_form_delete_allocation;

/** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */
const pl_admin_allocation_form_delete_allocation = en_admin_allocation_form_delete_allocation;

/** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */
const hu_admin_allocation_form_delete_allocation = en_admin_allocation_form_delete_allocation;

/** @type {(inputs: Admin_Allocation_Form_Delete_AllocationInputs) => LocalizedString} */
const ro_admin_allocation_form_delete_allocation = en_admin_allocation_form_delete_allocation;

/**
* | output |
* | --- |
* | "Delete this allocation." |
*
* @param {Admin_Allocation_Form_Delete_AllocationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_allocation_form_delete_allocation = /** @type {((inputs?: Admin_Allocation_Form_Delete_AllocationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Allocation_Form_Delete_AllocationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_allocation_form_delete_allocation(inputs)
	if (locale === "de") return de_admin_allocation_form_delete_allocation(inputs)
	if (locale === "es") return es_admin_allocation_form_delete_allocation(inputs)
	if (locale === "fr") return fr_admin_allocation_form_delete_allocation(inputs)
	if (locale === "nl") return nl_admin_allocation_form_delete_allocation(inputs)
	if (locale === "it") return it_admin_allocation_form_delete_allocation(inputs)
	if (locale === "pt-BR") return pt_br2_admin_allocation_form_delete_allocation(inputs)
	if (locale === "pl") return pl_admin_allocation_form_delete_allocation(inputs)
	if (locale === "hu") return hu_admin_allocation_form_delete_allocation(inputs)
	return ro_admin_allocation_form_delete_allocation(inputs)
});
export { admin_allocation_form_delete_allocation as "admin.allocation_form.delete_allocation" }